import links from "@/links/links";

export default {
  actions: {
    POST(item) {
      return this.post(links.BUILDING_OWNER_VOTING_RIGHT_POST(), item);
    },
    PUT(item) {
      return this.put(links.BUILDING_OWNER_VOTING_RIGHT_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.BUILDING_OWNER_VOTING_RIGHT_DELETE(item.id), {
        delete: item.id,
      });
    },
  },
};
